// extracted by mini-css-extract-plugin
module.exports = {"mr-city-404":"__404_mr-city-404__uamcr","image":"__404_image__mFIDj"};